<template>
  <div id="Tabs">
    <template>
      <div class="tabs-container" ref="tabsContainer" :class="{ none: tabs.length <= 1 }">
        <div class="tab" v-for="tab in tabs" @click="setActive(tab.element)" :key="tab.name"
          :class="{ active: activeTab && activeTab === tab.element, title: !tab.element }">
          {{ tab.tabName || tab.name }}
          <template v-if="tab.tag">&nbsp;({{tab.tag}})</template>
        </div>
      </div>
      <div class="page-content" ref="content">
        <slot></slot>
      </div>
    </template>
  </div>
</template>

<script>
  import EventBus from "../../resources/eventBus";

  export default {
    name: "Tabs",

    data() {
      return {
        tabs: [],
        activeTab: null
      }
    },

    async mounted() {
      EventBus.$on("setFirstTab", this.setFirstTab);
      var observer = new MutationObserver(() => {
        this.compileTabs();
      });
      observer.observe(this.$refs.content, {
        childList: true,
        subtree: true
      });
      this.compileTabs();
      this.setFirstTab();
      setTimeout(() => {
        this.$refs.tabsContainer.classList.add("transition");
      }, 100);
    },

    beforeDestroy() {
      EventBus.$off("setFirstTab");
    },

    methods: {
      setFirstTab() {
        if (this.tabs && this.tabs.length > 0) {
          this.setActive(this.tabs[0].element);
        }
      },
      compileTabs() {
        var sections = Array.from(this.$refs.content.querySelectorAll(".tab-section, .tab-title"));
        this.tabs = [];
        sections.forEach(section => {
          if (section.classList.contains("tab-section")) {
            this.tabs.push({
              name: section.getElementsByClassName("title__text")[0].innerText,
              tag: section.getElementsByClassName("tag")[0].innerText,
              tabName: section.getElementsByClassName("tabTitle")[0].innerText,
              element: this.$children.filter(child => child.$el === section)[0]
            });
          } else if (section.classList.contains("tab-title")) {
            this.tabs.push({
              name: section.innerText,
              element: null
            });
          }
        });
        if (this.activeTab === null) {
          this.setFirstTab();
        }
      },
      setActive(tab) {
        if (!tab) {
          return;
        }
        this.activeTab = tab;
        EventBus.$emit("setActiveTab", tab);
      }
    }
  }
</script>

<style lang="scss" scoped>
  #Tabs {
    display: flex;
    flex-grow: 1;

    .tabs-container {
      display: flex;
      flex-direction: column;
      padding-right: 24px;
      flex-shrink: 0;
      overflow-x: hidden;
      opacity: 1;
      margin-top: 20px;
      width: 233px;

      &.transition {
        transition: width 0.75s ease, padding 0.75s ease, opacity 1s ease 0.2s;
      }
      &.none {
        width: 0px;
        padding: 0;
        opacity: 0;
      }
    }

    .tab {
      width: 209px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      font-size: 14px;
      padding: 10px 20px 10px 0px;
      text-align: right;
      border-right: 2px solid #dbdbdb;
      transition: border-color 0.2s ease-in-out;

      &.active {
        text-shadow: 0.4px 0px rgb(64, 64, 64), -0.4px 0px rgb(64, 64, 64);
        border-color: var(--primary-color);
      }

      &.title {
        font-weight: bold;
        border-color: transparent;
        padding-top: 24px;
        cursor: default;
        color: var(--primary-color);

        &:hover {
          border-color: transparent;
        }
      }

      &:hover {
        border-color: var(--primary-color);
      }
    }

    .page-content {
      flex-grow: 1;
      min-width: 0;
      display: flex;
      flex-direction: column;
    }
  }

  #app.mobile #Tabs {
    flex-direction: column;

    .tabs-container {
      flex-direction: row;
      padding-right: 0;
      padding-bottom: 20px;
      overflow: auto;
      width: auto;
      max-width: 100%;
      align-self: center;
    }

    .tab {
      border-right: none;
      border-bottom: 2px solid #dbdbdb;
      padding: 10px 20px;
      align-items: flex-end;
      text-align: center;
      white-space: nowrap;
      width: auto;

      &.active {
        font-weight: bold;
        border-color: var(--primary-color);
      }

      &:hover {
        border-color: var(--primary-color);
      }
    }
  }
</style>